import { useEffect } from "react";

declare global {
  interface Window {
    Tawk_API?: any;
  }
}

export default function ChatWidget({ name, email }: { name?: string; email?: string }) {
  useEffect(() => {
    if (document.getElementById("tawk-script")) return;

    const script = document.createElement("script");
    script.id = "tawk-script";
    script.async = true;
    script.src = "https://embed.tawk.to/674b6c392480f5b4f5a63cf6/1idv9tgq7";
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");

    document.body.appendChild(script);

    script.onload = () => {
      if (window?.Tawk_API) {
        window.Tawk_API.onLoad = function () {
          // Apply custom styles
          window.Tawk_API.setAttributes(
            {
              ...(name && { name }),
              ...(email && { email }),
            },
            function (error: any) {
              console.log("Error setting attributes", error);
            },
          );
        };
      }
    };

    return () => {
      const existingScript = document.getElementById("tawk-script");
      if (existingScript) document.body.removeChild(existingScript);
    };
  }, []);

  return null;
}
